import { Directive, ElementRef, computed, effect, input } from "@angular/core";

@Directive({
    selector: "[appMarginLeft]"
})
export class MarginLeftDirective {
    marginLevel = input<number>(0);
    marginMultiplier = input<number>(16);

    private marginLeft = computed(() => {
        const level = this.marginLevel();
        const multiplier = this.marginMultiplier();
        if (level === 0) return 0;
        return (level + 1) * multiplier;
    });

    constructor(private elementRef: ElementRef) {
        effect(() => {
            const marginLeft = this.marginLeft();
            this.elementRef.nativeElement.style.marginLeft = `${marginLeft}px`;
        });
    }
}
